import { Injectable, inject } from '@angular/core';
import moment, { Moment } from 'moment';
import { Observable, from } from 'rxjs';
// var blinder = require('color-blind');

@Injectable({
  providedIn: 'root',
})
export class tools {
  constructor() { }

  public compareArray(obj1: any[], obj2: any[]): boolean {
    if (obj1.length != obj2.length) return false;
    for (let i = 0; i < obj1.length; i++) {
      if (obj1[i] != obj2[i]) return false;
    }
    return true;
  }

  public sortFileAsAsNumber(object: any): any {
    object.sort((a: any, b: any) => {
      const reg = new RegExp('^[0-9\.]+$');
      if (reg.test(a.fileAs) && reg.test(b.fileAs)) {
        let afileAs: string[] = [];
        let bfileAs: string[] = [];
        afileAs = a.fileAs.split('.');
        bfileAs = b.fileAs.split('.');
        for (let i = 0; i < afileAs.length; i++) {
          afileAs[i] = afileAs[i].padStart(4, '0');
        }
        for (let i = 0; i < bfileAs.length; i++) {
          bfileAs[i] = bfileAs[i].padStart(4, '0');
        }

        let aPaddedStart = afileAs.join('.');
        let bPaddedStart = bfileAs.join('.');
        return aPaddedStart > bPaddedStart ? 1 : -1;
      } else return a.fileAs > b.fileAs ? 1 : -1;
    });
    return object;
  }

  public guid(asDash?: boolean) {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    if (asDash != null && asDash == false) return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
    else return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  public getIsoDate(date: Date | string | Moment): string | null {
    if (typeof date == 'string') {
      if (date.length > 1) {
        let dateStr = new Date(date);
        let month = dateStr.getMonth() + 1;
        let monthStr = ('0' + month).slice(-2);
        let dayNumber = ('0' + dateStr.getDate()).slice(-2);
        return dateStr.getFullYear() + '-' + monthStr + '-' + dayNumber;
      } else return null;
    } else if (date instanceof Date) {
      let month = date.getMonth() + 1;
      let monthStr = ('0' + month).slice(-2);
      let dayNumber = ('0' + date.getDate()).slice(-2);
      return date.getFullYear() + '-' + monthStr + '-' + dayNumber;
    } else if (date instanceof moment) {
      let dateStr = date.toDate();
      let month = dateStr.getMonth() + 1;
      let monthStr = ('0' + month).slice(-2);
      let dayNumber = ('0' + dateStr.getDate()).slice(-2);
      return dateStr.getFullYear() + '-' + monthStr + '-' + dayNumber;
    } else return null;
  }

  public isASCII(str: string): boolean {
    return /^[\x00-\x7F]*$/.test(str);
  }

  public stringIsJSVariableCompatible(str: string): boolean {
    let returnValue = true;
    if (str.length == 0) returnValue = false;
    else if (this.isASCII(str)) {
      var re = /^\w+$/;
      if (!re.test(str)) {
        returnValue = false;
      } else if (/^\d/.test(str)) returnValue = false;
    } else returnValue = false;
    return returnValue;
  }

  public durationToMs(
    duration: number,
    unit: 'ms' | 'millisecond' | 's' | 'second' | 'm' | 'minute' | 'h' | 'hour' | 'd' | 'day' | 'w' | 'week' | 'M' | 'mounth' | 'y' | 'year',
    roundedResult: boolean = true,
  ): number | null {
    if (duration == undefined) return null;
    let returnValue;
    switch (unit) {
      case 'y':
        returnValue = duration * 1000 * 60 * 60 * 24 * 365;
        break;
      case 'year':
        returnValue = duration * 1000 * 60 * 60 * 24 * 365;
        break;
      case 'M':
        returnValue = duration * 1000 * 60 * 60 * 24 * 30.42;
        break;
      case 'mounth':
        returnValue = duration * 1000 * 60 * 60 * 24 * 30.42;
        break;
      case 'w':
        returnValue = duration * 1000 * 60 * 60 * 24 * 7;
        break;
      case 'week':
        returnValue = duration * 1000 * 60 * 60 * 24 * 7;
        break;
      case 'd':
        returnValue = duration * 1000 * 60 * 60 * 24;
        break;
      case 'day':
        returnValue = duration * 1000 * 60 * 60 * 24;
        break;
      case 'h':
        returnValue = duration * 1000 * 60 * 60;
        break;
      case 'hour':
        returnValue = duration * 1000 * 60 * 60;
        break;
      case 'm':
        returnValue = duration * 1000 * 60;
        break;
      case 'minute':
        returnValue = duration * 1000 * 60;
        break;
      case 's':
        returnValue = duration * 1000;
        break;
      case 'second':
        returnValue = duration * 1000;
        break;
      case 'ms':
        returnValue = duration;
        break;
      case 'millisecond':
        returnValue = duration;
        break;
    }
    if (roundedResult) return Math.round(returnValue * 100) / 100;
    else return returnValue;
  }

  public round2decimal(value: number) {
    return Math.round(value * 100) / 100;
  }

  public msToDuration(
    durationMs: number,
    unit: 'ms' | 's' | 'm' | 'h' | 'd' | 'w' | 'M' | 'y' | 'millisecond' | 'sec' | 'min' | 'hour' | 'day' | 'week' | 'month' | 'year',
    roundedResult: 0 | 2 | undefined = 2,
  ): number {
    let returnValue = 0;
    switch (unit) {
      case 'y':
        returnValue = durationMs / 1000 / 60 / 60 / 24 / 365;
        break;
      case 'year':
        returnValue = durationMs / 1000 / 60 / 60 / 24 / 365;
        break;
      case 'M':
        returnValue = durationMs / 1000 / 60 / 60 / 24 / 30.42;
        break;
      case 'month':
        returnValue = durationMs / 1000 / 60 / 60 / 24 / 30.42;
        break;
      case 'w':
        returnValue = durationMs / 1000 / 60 / 60 / 24 / 7;
        break;
      case 'week':
        returnValue = durationMs / 1000 / 60 / 60 / 24 / 7;
        break;
      case 'd':
        returnValue = durationMs / 1000 / 60 / 60 / 24;
        break;
      case 'day':
        returnValue = durationMs / 1000 / 60 / 60 / 24;
        break;
      case 'h':
        returnValue = durationMs / 1000 / 60 / 60;
        break;
      case 'hour':
        returnValue = durationMs / 1000 / 60 / 60;
        break;
      case 'm':
        returnValue = durationMs / 1000 / 60;
        break;
      case 'min':
        returnValue = durationMs / 1000 / 60;
        break;
      case 's':
        returnValue = durationMs / 1000;
        break;
      case 'sec':
        returnValue = durationMs / 1000;
        break;
      case 'ms':
        returnValue = durationMs;
        break;
      case 'millisecond':
        returnValue = durationMs;
        break;
    }

    if (roundedResult == 2) return Math.round(returnValue * 100) / 100;
    else if (roundedResult == 0) return Math.round(returnValue);
    else return returnValue;
  }

  public durationUnitEnToFr(
    duration: number,
    unit: 'ms' | 's' | 'm' | 'h' | 'd' | 'w' | 'M' | 'y' | 'millisecond' | 'sec' | 'min' | 'hour' | 'day' | 'week' | 'month' | 'year',
  ): string | null {
    let returnValue: string;
    switch (unit) {
      case 'y':
        returnValue = 'année';
        break;
      case 'year':
        returnValue = 'année';
        break;
      case 'M':
        returnValue = 'mois';
        break;
      case 'month':
        returnValue = 'mois';
        break;
      case 'w':
        returnValue = 'semaine';
        break;
      case 'week':
        returnValue = 'semaine';
        break;
      case 'd':
        returnValue = 'jour';
        break;
      case 'day':
        returnValue = 'jour';
        break;
      case 'h':
        returnValue = 'heure';
        break;
      case 'hour':
        returnValue = 'heure';
        break;
      case 'm':
        returnValue = 'minute';
        break;
      case 'min':
        returnValue = 'minute';
        break;
      case 's':
        returnValue = 'seconde';
        break;
      case 'sec':
        returnValue = 'seconde';
        break;
      case 'ms':
        returnValue = 'milliseconde';
        break;
      case 'millisecond':
        returnValue = 'milliseconde';
        break;
    }
    if (duration > 1 && returnValue.slice(-1) != 's')
      //sppecific case for 'mois'
      return returnValue + 's';
    else return returnValue;
  }

  public roundToHour(date: Date): Date {
    let msH = 60 * 60 * 1000; // milliseconds in an hour
    return new Date(Math.round(date.getTime() / msH) * msH);
  }

  //input time in second return string time
  public timeParser(duration: number): string {
    if (duration == undefined) return '';
    let strReturn = '';
    let days: number = 0;
    let minutes = 0;
    let hours = 0;
    let secondes = 0;

    secondes = Math.floor(duration % 60);
    minutes = Math.floor((duration / 60) % 60);
    hours = Math.floor((duration / (60 * 60)) % 24);
    days = Math.floor(duration / (60 * 60 * 24));

    let hoursStr = hours < 10 ? '0' + hours : hours;
    let minutesStr = minutes < 10 ? '0' + minutes : minutes;
    let daysStr = days.toString();
    if (days > 0) strReturn += daysStr + 'j ';
    if (days > 0 || hours > 0) strReturn += hoursStr + 'h';
    if (minutes > 0) strReturn += minutesStr + 'm';
    if (secondes > 0) strReturn += secondes + 's';

    if (strReturn == '') return '0';
    else return strReturn;
  }

  public delay(ms: number): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      setTimeout(resolve, ms);
    });

    return promise;
  }

  public delayObservable(ms: number): Observable<any> {
    let promise = new Promise((resolve, reject) => {
      setTimeout(resolve, ms);
    });
    return from(promise);
  }

  //remove char given in input from a string if it exist at the beginin and at the end
  public trimChar(path: string, char: string): string {
    if (path == undefined || path == '') return '';
    if (path.charAt(0) == char) {
      path = path.substring(1);
    }
    if (path.charAt(path.length - 1) == char) {
      path = path.substring(0, path.length - 1);
    }
    return path;
  }

  public logs(log?: any, ...optionalParams: any[]): void {
    console.log(window.location);
    console.log(log, optionalParams);
  }

  public pickTextColorBasedOnBgColorSimple(bgColor: string, lightColor: string, darkColor: string) {
    var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
  }

  public strMapToObj(obj: any) {
    let strMap = new Map();
    for (let k of Object.keys(obj)) {
      strMap.set(k, obj[k]);
    }
    return strMap;
  }

  public stringToColor(str: string): string {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    var color = '#';
    for (var i = 0; i < 3; i++) {
      var value = (hash >> (i * 8)) & 0xff;
      color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
  }

  public stringToHslColor(str: string, s: number = 60, l: number = 70): any {
    //generate colors from pseudo trigram string
    var hash = 0;
    for (var i = 0; i < str?.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    var h = hash % 360;
    return { h: h, s: s, l: l };
  }

  public hslColorAsString(hsl: any): string {
    return 'hsl(' + hsl.h + ', ' + hsl.s + '%, ' + hsl.l + '%)';
  }

  public hslToHex(hslBase: any) {
    let hsl = JSON.parse(JSON.stringify(hslBase));
    hsl.l /= 100;
    const a = (hsl.s * Math.min(hsl.l, 1 - hsl.l)) / 100;
    const f = (n: any) => {
      const k = (n + hsl.h / 30) % 12;
      const color = hsl.l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * color)
        .toString(16)
        .padStart(2, '0'); // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
  }

  public colorToBlind(baseColor: string, group: colorBlindType): string {
    let convertedColor = baseColor;
    switch (group.type) {
      // case 'Achromatomaly':
      //   convertedColor = blinder.Achromatomaly(baseColor, false);
      //   break;
      // case 'Achromatopsia':
      //   convertedColor = blinder.Achromatopsia(baseColor, false);
      //   break;
      // case 'Deuteranomaly':
      //   convertedColor = blinder.Deuteranomaly(baseColor, false);
      //   break;
      // case 'Deuteranopia':
      //   convertedColor = blinder.Deuteranopia(baseColor, false);
      //   break;
      // case 'Protanomaly':
      //   convertedColor = blinder.Protanomaly(baseColor, false);
      //   break;
      // case 'Protanopia':
      //   convertedColor = blinder.Protanopia(baseColor, false);
      //   break;
      // case 'Tritanomaly':
      //   convertedColor = blinder.Tritanomaly(baseColor, false);
      //   break;
      // case 'Tritanopia':
      //   convertedColor = blinder.Achromatomaly(baseColor, false);
      //   break;
    }
    return convertedColor;
  }

  public hexToHSL(hex: string): { h: number; s: number; l: number } {
    //remove transparencyColor
    if (hex.length == 9) hex = hex.slice(0, -2);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) {
      throw new Error('Could not parse Hex Color');
    }
    const rHex = parseInt(result[1], 16);
    const gHex = parseInt(result[2], 16);
    const bHex = parseInt(result[3], 16);
    const r = rHex / 255;
    const g = gHex / 255;
    const b = bHex / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h = (max + min) / 2;
    let s = h;
    let l = h;
    if (max === min) {
      // Achromatic
      return { h: 0, s: 0, l };
    }
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
    s = s * 100;
    s = Math.round(s);
    l = l * 100;
    l = Math.round(l);
    h = Math.round(360 * h);
    return { h, s, l };
  }

  private rgbToYIQ({ r, g, b }: any): number {
    return (r * 299 + g * 587 + b * 114) / 1000;
  }

  private hexToRgb(hex: string): any | undefined {
    if (!hex || hex === undefined || hex === '') {
      return undefined;
    }
    const result: RegExpExecArray | null = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
      : undefined;
  }

  private rgbToHex(r: number, g: number, b: number): string {
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  public contrastColorText(colorHex: string | undefined, threshold: number = 128): string {
    if (colorHex === undefined) {
      return '#000';
    }
    const rgb: any | undefined = this.hexToRgb(colorHex);
    if (rgb === undefined) {
      return '#000';
    }
    return this.rgbToYIQ(rgb) >= threshold ? '#000' : '#fff';
  }

  public PercentageToGreenRedColor(percentage: number, opacity: string = 'FF'): string {
    // percentage between 0 and 100, return color in hex
    let green: number = percentage * 2.55;
    let red: number = (1 - percentage) * 2.55;
    return this.rgbToHex(red, green, 0) + opacity;
  }

  public negativeDecimalColorToHexColor(color: number) {
    //input format see https://stackoverflow.com/questions/42633608/convert-negative-color-numbers-to-hex-or-rgb
    if (color == undefined) return '';
    let colorValue = 16777216 + color;
    let colorHex = colorValue.toString(16);
    while (colorHex.length < 6) {
      colorHex = '0' + colorHex;
    }
    return '#' + colorHex;
  }

  public isSafari(): boolean {
    let is_ios = /iP(ad|od|hone)/i.test(window.navigator.userAgent);
    let is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    return is_ios || is_safari;
  }

  public isRunningOnMobile(): boolean {
    let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return isMobile;
  }

  public hasExternalWindowsCapability(): boolean {
    let hasCapability = true;
    if (this.isSafari() || this.isRunningOnMobile()) hasCapability = false;
    return hasCapability;
  }

  public isFirefox(): boolean {
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) return true;
    else return false;
  }

  public getAncestorOrigins() {
    if (location.ancestorOrigins !== undefined) {
      return document.location.ancestorOrigins;
    }
    const urls: string[] = [];
    let parentWin = window;
    while (parentWin !== window.top) {
      if (parentWin.document.referrer) {
        try {
          const url = new URL(parentWin.document.referrer);
          urls.push(url.origin);
        } catch (e) {
          // console.error
        }
      }
      // @ts-ignore
      parentWin = parentWin.parent;
    }
    return urls;
  }

  public windowHasMenuBar(): boolean {
    //In D4 context a window without menuBar is equivalent to a window children
    return window.menubar.visible;
  }

  public isWebKit(): boolean {
    var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    if (isChrome || isSafari) {
      return true;
    }
    return false;
  }

  /*
    itmes in array must contain rank object
  */
  public findNextRank(list: any[], rankNameObject: string = 'rank'): number {
    let nextRank = 0;
    for (let i = 0; i < list.length; i++) {
      if (list[i][rankNameObject] > nextRank) nextRank = list[i][rankNameObject];
    }
    let nextRankCeil = 10 * Math.ceil(nextRank / 10); //arrondie à la dizaine supérieur
    if (nextRankCeil == nextRank) nextRank = nextRank + 10;
    else nextRank = nextRankCeil;
    return nextRank;
  }
}

// @Injectable({ providedIn: 'root' })
// export class ExcelService {
//   constructor() { }

//   public exportAsExcelFile(json: any[], excelFileName: string): void {
//     import('xlsx').then((XLSX) => {
//       const worksheet = XLSX.utils.json_to_sheet(json);
//       const workbook = {
//         Sheets: { donnee: worksheet },
//         SheetNames: ['donnee'],
//       };
//       let date: Date = new Date();
//       let fileName = `${excelFileName} ${date.getDate()}-${date.getMonth()} ${date.getHours()}h${date.getMinutes()}.xlsx`;
//       XLSX.writeFile(workbook, fileName);
//     });
//   }

//   public importExcelFileToJSON(file: File): Promise<any> {
//     let fileReader = new FileReader();
//     return new Promise((resolve, reject) => {
//       fileReader.onerror = () => {
//         fileReader.abort();
//         reject(new DOMException('Problem parsing input file.'));
//       };
//       fileReader.onload = () => {
//         // resolve(fileReader.result);
//         let arrayBuffer: any;
//         arrayBuffer = fileReader.result;
//         var data = new Uint8Array(arrayBuffer);
//         var arr = new Array();
//         for (var i = 0; i != data.length; ++i) {
//           arr[i] = String.fromCharCode(data[i]);
//         }
//         var bstr = arr.join('');
//         return import('xlsx').then((XLSX) => {
//           var workbook = XLSX.read(bstr, { type: 'binary' });
//           var first_sheet_name = workbook.SheetNames[0];
//           var worksheet = workbook.Sheets[first_sheet_name];
//           let jsonObj = XLSX.utils.sheet_to_json(worksheet, { raw: true });
//           resolve(jsonObj);
//           return jsonObj;
//         });
//       };
//       fileReader.readAsArrayBuffer(file);
//     });
//   }
// }

export function getBaseLocation() {
  let paths: string[] = location.pathname.split('/').splice(1, 1);
  let basePath: string = (paths && paths[0]) || 'home'; // Default: home
  console.log('return basePath : /' + basePath);
  return '/' + basePath;
}

export interface HashTable<T> {
  [key: string]: T;
}

export interface colorBlindType {
  type: 'Protanomaly' | 'Achromatopsia' | 'Achromatomaly' | 'Protanopia' | 'Deuteranopia' | 'Tritanopia' | 'Deuteranomaly' | 'Tritanomaly';
}
